import React from 'react';
import { Tag } from 'components';

type Props = {
  value: {
    id: number;
    url: string;
  }[];
};

const QuizTags = ({ value }: Props) => {
  const openQuizForm = (url: string) => {
    window.open(url, '_blank');
  };

  return (
    <div>
      {value.map((item, index) => (
        <Tag key={index} variant="secondary" onClick={() => openQuizForm(item.url)}>
          Quiz
        </Tag>
      ))}
    </div>
  );
};

export default QuizTags;
